import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { REPEAT_LABELS, SHOP_REQUEST_TYPE, SHOP_REQUEST_TYPE_TAG_LABELS } from '../constants';
import { MysteryShopRequestInbound } from '../types';

const Container = styled.div`
  display: flex;
  flex-flow: column;
`;

const Title = styled(Typography.Text)`
  font-family: var(--font-bold);
  height: 21px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 290px;
`;

const StyledSubTitle = styled(Typography.Text)`
  color: var(--text-secondary);
  font-size: 12px;
  height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 290px;
`;

const RequestTypeTag = styled.span`
  align-self: flex-start;
  background: var(--faded-blue);
  border-radius: 3px;
  color: var(--dark-blue);
  font-family: var(--font-bold);
  font-size: 10px;
  letter-spacing: 0.4px;
  margin-top: 3px;
  padding: 2px 5px;
`;

type Props = {
  shopRequest: MysteryShopRequestInbound;
};

const ShopRequestCommunity = ({ shopRequest }: Props) => {
  return (
    <Container className="community-column">
      <Title>{shopRequest.community?.comunity_name || shopRequest.name}</Title>
      <StyledSubTitle>
        {REPEAT_LABELS[shopRequest.repeat] ? `${REPEAT_LABELS[shopRequest.repeat]} · ` : ''}
        {shopRequest.requestGroup?.company ? shopRequest.requestGroup.company.name : 'Further'}
      </StyledSubTitle>
      {shopRequest.request_type !== SHOP_REQUEST_TYPE.MYSTERY_SHOP && (
        <RequestTypeTag>{SHOP_REQUEST_TYPE_TAG_LABELS[shopRequest.request_type]}</RequestTypeTag>
      )}
    </Container>
  );
};

export default ShopRequestCommunity;
